import { render, staticRenderFns } from "./InventoryDataTable.vue?vue&type=template&id=3270fa1a&scoped=true"
import script from "./InventoryDataTable.vue?vue&type=script&lang=js"
export * from "./InventoryDataTable.vue?vue&type=script&lang=js"
import style0 from "./InventoryDataTable.vue?vue&type=style&index=0&id=3270fa1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270fa1a",
  null
  
)

export default component.exports